import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-print-report',
  templateUrl: './print-report.component.html',
  styleUrls: ['./print-report.component.scss']
})
export class PrintReportComponent implements OnInit ,AfterViewInit  {

  idvalue: string | null = null;
  reportUrl: string  = "";

  ids: number[] = []

  filters : any

  @ViewChild(ReportViewerComponent, { static: false })
  viewer!: ReportViewerComponent;
  constructor(private route: ActivatedRoute, private gt : genericCustomStoreService ) { }
  ngAfterViewInit(): void {
    debugger
    this.viewer.submitParameter(this.filters,this.reportUrl)
  }

ngOnInit(): void {
  this.gt.$Ids.subscribe((ids: any) => {
    this.ids = ids || [];
    this.filters = { id: this.ids };

    this.gt.$Url.pipe(take(1)).subscribe((url: string) => {
      this.reportUrl = url && url !== '' 
        ? url 
        : (this.route.snapshot.paramMap.get('reportUrl') ?? '');

      console.log('filters', this.filters);
      console.log('reportUrl', this.reportUrl);

      // Send parameters to viewer
      if (this.viewer) {
        this.viewer.submitParameter(this.filters, this.reportUrl);
      }

      // ✅ Clear $Url immediately after using it
      this.gt.$Url.next('');
    });
  });
}


  sendtomail(){
    
    let queryString = '';
  if (this.filters && Object.keys(this.filters).length) {
    queryString = '?' + new URLSearchParams(this.filters).toString();
  }

  const fullUrl = this.reportUrl + queryString;

  this.gt.sendreportmail(fullUrl).subscribe({
    next: (res) => {
      console.log('Mail sent successfully', res);

      // ✅ Clear $Url after sending
      this.gt.$Url.next('');
    },
    error: (err) => console.error('Mail sending failed', err)
  });


  }



}
